import type { ScienceId } from '@kaeliux/shared';

// Fundamental
import mathematics from '../assets/images/sciences/science_mathematics.png';
import physics from '../assets/images/sciences/science_physics.png';
import chemistry from '../assets/images/sciences/science_chemistry.png';
import astronomy from '../assets/images/sciences/science_astronomy.png';
import ecology from '../assets/images/sciences/science_ecology.png';

// Engineering
import architecture from '../assets/images/sciences/science_architecture.png';
import signalSystems from '../assets/images/sciences/science_signal_systems.png';
import rockets from '../assets/images/sciences/science_rockets.png';
import aerodynamics from '../assets/images/sciences/science_aerodynamics.png';
import wormholes from '../assets/images/sciences/science_wormholes.png';
import gravitationalManipulators from '../assets/images/sciences/science_gravitational_manipulators.png';

// Warfare
import intelligence from '../assets/images/sciences/science_intelligence.png';
import defenceSystems from '../assets/images/sciences/science_defence_systems.png';
import laser from '../assets/images/sciences/science_laser.png';
import ion from '../assets/images/sciences/science_ion.png';
import plasma from '../assets/images/sciences/science_plasma.png';
import polymerShields from '../assets/images/sciences/science_polymer_shields.png';
import carbonFiberShields from '../assets/images/sciences/science_carbon_fiber_shields.png';
import heavyMetalShields from '../assets/images/sciences/science_heavy_metal_shields.png';
import offensiveTactics from '../assets/images/sciences/science_offensive_tactics.png';
import defensiveTactics from '../assets/images/sciences/science_defensive_tactics.png';
import surpriseTactics from '../assets/images/sciences/science_surprise_tactics.png';

/** Sciences are race-agnostic (a single generic Research Center gates all of them), so this is a flat map, unlike `getBuildingIcon`/`getShipIcon`. */
const SCIENCE_SPRITES: Record<ScienceId, string> = {
    mathematics,
    physics,
    chemistry,
    astronomy,
    ecology,
    architecture,
    signalSystems,
    rockets,
    aerodynamics,
    wormholes,
    gravitationalManipulators,
    intelligence,
    defenceSystems,
    laser,
    ion,
    plasma,
    polymerShields,
    carbonFiberShields,
    heavyMetalShields,
    offensiveTactics,
    defensiveTactics,
    surpriseTactics,
};

/** Resolves the sprite for a science. */
export function getScienceIcon(scienceId: ScienceId): string {
    return SCIENCE_SPRITES[scienceId];
}
